import { defaultTheme } from './themes/defaultTheme';
import { idStainMouthwashTheme } from './themes/idStainMouthwashTheme';
import { toothArmourTheme } from './themes/toothArmourTheme';
import { toothWipesTheme } from './themes/toothWipesTheme';
import { truFitTheme } from './themes/truFitTheme';
import { defineAsyncComponent } from 'vue';
import type { region } from '@/composables/regionHelpers';
import type { SiteModal } from '@/features/SiteModal/types/models';

export type {
  CollectionBannerMedia,
  FreeGiftProduct,
  GlobalProductPill,
  HomeSaleBannerData,
  HomeShowcaseMode,
  ThemeData,
} from './models';

const themes = {
  defaultTheme,
  toothWipesTheme,
  idStainMouthwashTheme,
  toothArmourTheme,
  truFitTheme,
};

type ThemeKey = keyof typeof themes;

const fallbackTheme: ThemeKey = 'toothWipesTheme';

declare global {
  interface Window {
    global_theme?: string;
    global_home_theme?: string;
    global_legal_notice?: boolean | null;
    global_free_gift?: boolean | null;
    global_vault_active?: boolean | null;
  }
}

const requestedTheme = window.global_theme?.trim();

const currentTheme: ThemeKey =
  requestedTheme && requestedTheme in themes ? (requestedTheme as ThemeKey) : fallbackTheme;

const theme = themes[currentTheme];

const currentHomeTheme = 'whiteningProtocol';

export const fallbackHomeTheme = 'default';

export const homeTheme = window.global_home_theme?.trim() || currentHomeTheme;

export const {
  freeGiftProduct,
  collectionBanner,
  collectionBannerHideText,
  homeHero,
  homeHeroBanner,
  homeSaleBanner,
  homeShowcaseMode,
  homeShowcaseOptions,
  homeShowcaseContent,
  homeShowcaseMedia,
  homeShowcaseMediaLink,
  navImageBlocks,
  marqueeData,
  delayedShippingMessages,
  globalProductPill,
  globalProductCardBadge,
  globalProductImageBadge,
} = theme;

export const vaultActive = window.global_vault_active === true;

const siteModals = {
  welcome: defineAsyncComponent(
    () => import('@/features/SiteModal/components/SiteModalWelcome.vue'),
  ),
  blackFridayEarlyAccess: defineAsyncComponent(
    () => import('@/features/SiteModal/components/SiteModalBlackFridayEarlyAccess.vue'),
  ),
};

export const activeSiteModal: region<SiteModal | null> = {
  default: {
    component: siteModals.blackFridayEarlyAccess,
    delay: 30000,
    signUpTag: 'black_friday_early_access_2026',
  },
};

export const legalNotice: region<boolean> =
  window.global_legal_notice == null ? theme.legalNotice : { default: window.global_legal_notice };
